/* eslint-disable */
import { registerPlugin } from '@capacitor/core';

import type { DrmPlayerPlugin } from './definitions';

const DrmPlayer = registerPlugin<DrmPlayerPlugin>('DrmPlayer', {
  web: () => import('./web').then((m) => new m.DrmPlayerWeb()),
});

export * from './definitions';
export { DrmPlayer };
